module.exports = __webpack_public_path__ + "static/img/2.2246b2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/2.png
// module id = pu/3
// module chunks = 0